var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogistique(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.785 15.776h7.963c.546 0 .988.443.988.989v7.527a.988.988 0 01-.988.988h-7.963a.988.988 0 01-.988-.988v-7.527c0-.546.442-.989.988-.989z",
    fill: "#E74536"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.793 29.583c-1.247 0-2.259-.97-2.259-2.167v-7.044h19.2v9.211H2.794z",
    fill: "#0F1941",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.734 2c.59 0 1.067.478 1.067 1.067v25.45a1.067 1.067 0 01-2.133 0V3.066c0-.59.477-1.067 1.066-1.067z",
    fill: "#0F1941",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.56 26.332h11.149a.825.825 0 010 1.65h-11.15a.825.825 0 010-1.65z",
    fill: "#0F1941",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.097 25.24)",
    fill: "#2175D9",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.904,
    cy: 2.718,
    rx: 2.667,
    ry: 2.709
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.667,
    cy: 2.709,
    rx: 2.667,
    ry: 2.709
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.972 27.183)",
    fill: "#F7F5F0",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13.029,
    cy: 0.774,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.762.025c.42 0 .762.347.762.774a.768.768 0 01-.762.774A.768.768 0 010 .799C0 .372.341.025.762.025z"
  })))));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzMiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMyAzMiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZD0iTTIyLjc4NSAxNS43NzZoNy45NjNjLjU0NiAwIC45ODguNDQzLjk4OC45ODl2Ny41MjdhLjk4OC45ODggMCAwIDEtLjk4OC45ODhoLTcuOTYzYS45ODguOTg4IDAgMCAxLS45ODgtLjk4OHYtNy41MjdjMC0uNTQ2LjQ0Mi0uOTg5Ljk4OC0uOTg5eiIgZmlsbD0iI0U3NDUzNiIvPgogICAgICAgIDxwYXRoIGQ9Ik0yLjc5MyAyOS41ODNjLTEuMjQ3IDAtMi4yNTktLjk3LTIuMjU5LTIuMTY3di03LjA0NGgxOS4ydjkuMjExSDIuNzk0eiIgZmlsbD0iIzBGMTk0MSIgZmlsbC1ydWxlPSJub256ZXJvIi8+CiAgICAgICAgPHBhdGggZD0iTTE5LjczNCAyYy41OSAwIDEuMDY3LjQ3OCAxLjA2NyAxLjA2N3YyNS40NWExLjA2NyAxLjA2NyAwIDAgMS0yLjEzMyAwVjMuMDY2YzAtLjU5LjQ3Ny0xLjA2NyAxLjA2Ni0xLjA2N3oiIGZpbGw9IiMwRjE5NDEiIGZpbGwtcnVsZT0ibm9uemVybyIvPgogICAgICAgIDxwYXRoIGQ9Ik0yMC41NiAyNi4zMzJoMTEuMTQ5YS44MjUuODI1IDAgMCAxIDAgMS42NWgtMTEuMTVhLjgyNS44MjUgMCAwIDEgMC0xLjY1eiIgZmlsbD0iIzBGMTk0MSIgZmlsbC1ydWxlPSJub256ZXJvIi8+CiAgICAgICAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMS4wOTcgMjUuMjQpIiBmaWxsPSIjMjE3NUQ5IiBmaWxsLXJ1bGU9Im5vbnplcm8iPgogICAgICAgICAgICA8ZWxsaXBzZSBjeD0iMTQuOTA0IiBjeT0iMi43MTgiIHJ4PSIyLjY2NyIgcnk9IjIuNzA5Ii8+CiAgICAgICAgICAgIDxlbGxpcHNlIGN4PSIyLjY2NyIgY3k9IjIuNzA5IiByeD0iMi42NjciIHJ5PSIyLjcwOSIvPgogICAgICAgIDwvZz4KICAgICAgICA8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyLjk3MiAyNy4xODMpIiBmaWxsPSIjRjdGNUYwIiBmaWxsLXJ1bGU9Im5vbnplcm8iPgogICAgICAgICAgICA8Y2lyY2xlIGN4PSIxMy4wMjkiIGN5PSIuNzc0IiByPSIxIi8+CiAgICAgICAgICAgIDxwYXRoIGQ9Ik0uNzYyLjAyNWMuNDIgMCAuNzYyLjM0Ny43NjIuNzc0YS43NjguNzY4IDAgMCAxLS43NjIuNzc0QS43NjguNzY4IDAgMCAxIDAgLjc5OUMwIC4zNzIuMzQxLjAyNS43NjIuMDI1eiIvPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+Cg==";
export { SvgLogistique as ReactComponent };